import { combineReducers } from "@reduxjs/toolkit";
// import AuthSlice from "./crmSlices/authSlice/AuthSlice";
import DashboardSlice from "./crmSlices/dashboardSlice/DashboardSlice";
import EmployeeSlice from "./crmSlices/employeeSlice/EmployeeSlice";
import AttendanceSlice from "./crmSlices/attendanceSlice/AttendanceSlice";
import TaskSlice from "./crmSlices/taskSlice/TaskSlice";

import EventSlice from "./crmSlices/eventSlice/EventSlice";
import ExpenseSlice from "./crmSlices/expenseSlice/ExpenseSlice";
import UserSlice from "./remarkSlice/userSlice/UserSlice";
import WorkUpdateSlice from "./crmSlices/workUpdateSlice/WorkUpdateSlice";
import RemarkDashboardSlice from "./remarkSlice/remarkDashboardSlice/RemarkDashboardSlice";
import OfficeSeatSlice from "./crmSlices/officeSeatSlice/OfficeSeatSlice";
import CompanyKycSlice from "./remarkSlice/companyKyc/CompanyKycSlice";
import InquirySlice from "./remarkSlice/inquiry/InquirySlice";
import JobSlice from "./remarkSlice/jobSlice/JobSlice";
import EmployerSlice from "./remarkSlice/employer/EmployerSlice";
import CompanySlice from "./remarkSlice/company/CompanySlice";
import CandidateSlice from "./remarkSlice/candidate/CandidateSlice";
import PropertySlice from "./fractionSlice/property/PropertySlice";
import TicketSlice from "./crmSlices/ticketSlice/TicketSlice";
import ClientSlice from "./fractionSlice/client/ClientSlice";
import PurchasedPropertySlice from "./fractionSlice/purchaseProperty/PurchasePropertySlice";
import RoleSlice from "./crmSlices/roleSlice/RoleSlice";
import RecentlyActivitySlice from "./crmSlices/recentActivitySlice/RecentActivitySlice";
import InterviewSlice from "./crmSlices/interviewSlice/InterviewSlice";
import MarketingSlice from "./crmSlices/marketingSlice/MarketingSlice";
import GallerySlice from "./crmSlices/gallerySlice/GallerySlice";
import InternshipSlice from "./remarkSlice/internship/InternshipSlice";
import QuizSlice from "./remarkSlice/quiz/QuizSlice";
import ShortlistSlice from "./remarkSlice/shortlist/ShortlistSlice";
import InquiryFractionSlice from "./fractionSlice/inquiry/InquiryFractionSlice";
import RequestSlice from "./fractionSlice/request/RequestSlice";
import AnalyticFracSlice from "./fractionSlice/dashboard/AnalyticFracSlice";
import LlpFractionSlice from "./fractionSlice/llp/LlpFractionSlice";
import NotificationSlice from "./crmSlices/notificationSlice/NotificationSlice";
import EssentialSlice from "./crmSlices/essentialSlice/EssentialSlice";
import BuilderSlice from "./fractionSlice/builder/BuilderSlice";
import LaunchSlice from "./fractionSlice/launch/LaunchSlice";
import LayoutSlice from "./crmSlices/layoutSlice/LayoutSlice";
import RemarkLeadSlice from "./remarkSlice/leadSlice/RemarkLeadSlice"; //param
import EducationSlice from "./remarkSlice/educationSlice/EducationSlice"; //param
import LeaveSlice from "./crmSlices/leaveSlice/LeaveSlice";
import SSLSlice from "./crmSlices/sslSlices/SslSlice";
import OrderSlice from "./remarkSlice/orderSlice/OrderSlice";
import SubscriptionSlice from "./remarkSlice/subscriptionSlice/SubscriptionSlice";
import paymentSlice from "./crmSlices/paymentsSlice/PaymentsSlice";
import UserActivityRemarkSlice from "./remarkSlice/userActivityRemarkSlice/UserActivityRemarkSlice";
import HrHandBookSlice from "./crmSlices/hrHandBookSlice/HrHandBookSlice";
import emailSystemSlice from "./crmSlices/emailSystemSlice/EmailSystemSlice";
import FestivalSlice from "./crmSlices/festiveSlice/FestivalSlice";
import SeoContentSlice from "./crmSlices/seoContentSlice/SeoContentSlice";
import remarkUserSlice from "./crmSlices/remarkUserSlice/RemarkUserSlice";
import TrackerSlice from "./crmSlices/trackerSlice/TrackerSlice";
import TicketRemarkSlice from "./remarkSlice/ticketRemarkSlice/TicketRemarkSlice";
import RemarkTicketConversationSlice from "./remarkSlice/remarkTicketConversationSlice/RemarkTicketConversationSlice";
import AboutSlice from "./realEstateSlice/aboutSlice/AboutSlice";
import ServicesSlice from "./realEstateSlice/servicesSlice/ServicesSlice";
import CompanyGoalSlice from "./realEstateSlice/companyGoalSlice/CompanyGoalSlice";
import UsersSlice from "./realEstateSlice/usersSlice/UsersSlice";
import AuthenticationSlice from "./realEstateSlice/authenticationSlice/AuthenticationSlice";
import RealEstateLeadSlice from "./realEstateSlice/RealEstateLeadSlice/RealEstateLeadSlice";
import TrackerReferenceSlice from "./remarkSlice/trackerReferenceSlice/TrackerReferenceSlice";
import PropertiesSlice from "./realEstateSlice/propertiesSlice/PropertiesSlice";
import EmailSlice from "./remarkSlice/emailRecordSlice/EmailSlice";
import DeveloperSlice from "./realEstateSlice/developerSlice/DeveloperSlice";
import AiChatListSlice from "./remarkSlice/aiChatSlice/AiChatListSlice";
import AgenticSlice from "./remarkSlice/agenticSlice/AgenticSlice";
import AgenticHireCandidateslice from "./remarkSlice/agenticHireCandidateSlice/AgenticHireCandidateSlice";
import AgenticInterviewSlice from "./remarkSlice/agenticInterviewSlice/AgenticInterviewSlice";
import AppliedInternshipSlice from "./remarkSlice/appliedInternshipSlice/AppliedInternshipSlice";
import DesignationSlice from "./remarkSlice/designation/DesignationSlice";
import EducationListSlice from "./remarkSlice/education/EducationListSlice";
import EmailTemplateSlice from "./remarkSlice/emailTemplateSlice/EmailTemplateSlice";
import FaqSlice from "./remarkSlice/faqSlice/FaqSlice";
import FilterSlice from "./remarkSlice/filterSlice/FilterSlice";
import HotLeadSlice from "./remarkSlice/hotLeadSlice/HotLeadSlice";
import HotVacancySlice from "./remarkSlice/hotVacancySlice/HotVacancySlice";
import IndustrySlice from "./remarkSlice/industrySlice/IndustrySlice";
import CategorySlice from "./remarkSlice/categorySlice/CategorySlice";
import LeadFeedbackSlice from "./remarkSlice/leadFeedbackSlice/LeadFeedbackSlice";
import SaveProfileSlice from "./remarkSlice/saveProfileSlice/SaveProfileSlice";
import UserSearchesSlice from "./remarkSlice/userSearchesSlice/UserSearchesSlice";
import FieldMarketingSlice from "./crmSlices/fieldMarketingSlice/FieldMarketingSlice";
import StateCountrySlice from "./remarkSlice/stateCountrySlice/StateCountrySlice";
import EventsSlice from "./remarkSlice/eventsSlice/EventsSlice";
import LeadSlice from "./crmSlices/leadSlice/LeadSlice";
import CvSlice from "./remarkSlice/cvSlice/CvSlice";
import ContactsSlice from "./hummingSlice/contactsSlice/ContactsSlice";
import EmojisSlice from "./hummingSlice/emojisSlice/EmojisSlice";
import MessagesSlice from "./hummingSlice/messagesSlice/MessagesSlice";
import ReportSlice from "./hummingSlice/reportSlice/ReportSlice";
import RoomsSlice from "./hummingSlice/roomsSlice/RoomsSlice";
import SettingSlice from "./hummingSlice/settingSlice/SettingSlice";
import ScheduledMessageSlice from "./hummingSlice/scheduledMessageSlice/ScheduledMessageSlice";
import AllUserSlice from "./hummingSlice/alluserSlice/AllUserSlice";
import PricingSlice from "./remarkSlice/pricingSlice/PricingSlice";
import CouponSlice from "./remarkSlice/couponSlice/CouponSlice";
import RLeadSlice from "./remarkSlice/RLeadSlice/RLeadSlice";
import TempUserSlice from "./remarkSlice/tempUserSlice/TempUserSlice";
import MarketingLeadSlice from "./remarkSlice/marketingLeadSlice/MarketingLeadSlice";
import BulkResumeSlice from "./remarkSlice/bulkResumeSlice/BulkResumeSlice";
import JobRequireSlice from "./remarkSlice/jobRequireSlice/JobRequireSlice";
import ResumeShortListSlice from "./remarkSlice/resumeShortlistSlice/ResumeShortListSlice"
import JobFairSlice from "./remarkSlice/jobFairSlice/JobFairSlice";
import CustomerSlice from "./crmSlices/customerSlice/CustomerSlice";
import GoalSlice from "./crmSlices/goalSlice/GoalSlice";
import EndToEndHiringSlice from "./remarkSlice/endToendHiring/EndToEndHiringSlice";
import WhatsappSlice from "./crmSlices/whatsappSlice/WhatsappSlice";
import CareerSlice from "./crmSlices/careerSlice/CareerSlice";
import authSlice from "./crmSlices/authSlice/AuthSlice";
import WalkinInterviewSlice from "./crmSlices/walkinInterviewSlice/WalkinInterviewSlice";
import ImportAndRecycleLeadSlice from "./crmSlices/ImportAndRecycleLeadSlice/ImportAndRecycleLeadSlice";
import NewEndToEndHiringSlice from "./crmSlices/newEndToEndHiringSlice/NewEndToEndHiringSlice";
import CustomerSupportActivitySlice from "./remarkSlice/customerSupportActivitySlice/CustomerSupportActivitySlice";
import AllPaymentSlice from "./crmSlices/allPaymentSlice/AllPaymentSlice";

import PayrollContractSlice from "./crmSlices/payrollSlice/payrollContractSlice/PayrollContractSlice";
import SalaryStructureSlice from "./crmSlices/payrollSlice/salaryStructureSlice/SalaryStructureSlice";
import PayrollRulesSlice from "./crmSlices/payrollSlice/payrollRulesSlice/PayrollRulesSlice";
import GeneratePayrollSlice from "./crmSlices/payrollSlice/generatePayrollSlice/GeneratePayrollSlice";
import CounterSlice from "./remarkSlice/counterSlice/CounterSlice";
import ResumeDownloadTimerSlice from "./remarkSlice/resumeDownloadTimerSlice/ResumeDownlaodTimerSlice";
import FieldVisitSlice from "./crmSlices/fieldVisitSlice/FieldVisitSlice";
import AutomationMarketingSlice from "./crmSlices/automationMarketingSlice/AutomationMarketingSlice";
import SalesReportSlice from "./crmSlices/salesReportsSlice/SalesReportSlice";
import InstituteQrSlice from "./remarkSlice/instituteqrSlice/InstituteQrSlice";

const rootReducer = combineReducers({
  // Visko CRM Slice
  // AuthSlice,
  authSlice,
  HrHandBookSlice,
  GoalSlice,
  DashboardSlice,
  EmployeeSlice,
  AttendanceSlice,
  TaskSlice,
  LeadSlice,
  EventSlice,
  FestivalSlice,
  ExpenseSlice,
  WorkUpdateSlice,
  OfficeSeatSlice,
  TicketSlice,
  RoleSlice,
  CareerSlice,
  SalesReportSlice,


  GallerySlice,
  InterviewSlice,
  WalkinInterviewSlice,
  MarketingSlice,
  NotificationSlice,
  EssentialSlice,
  LayoutSlice,
  SeoContentSlice,
  remarkUserSlice,
  TrackerSlice,
  emailSystemSlice,
  FieldMarketingSlice,
  RecentlyActivitySlice,
  CustomerSlice,
  WhatsappSlice,
  ImportAndRecycleLeadSlice,
  NewEndToEndHiringSlice,
  AllPaymentSlice,
  FieldVisitSlice,
  AutomationMarketingSlice,


  // Remark Slices
  UserSlice,
  RemarkDashboardSlice,
  CompanyKycSlice,
  InquirySlice,
  JobSlice,
  EmployerSlice,
  CompanySlice,
  CandidateSlice,
  InternshipSlice,
  QuizSlice,
  ShortlistSlice,
  RemarkLeadSlice, //param
  EducationSlice, //param
  UserActivityRemarkSlice,
  TicketRemarkSlice,
  RemarkTicketConversationSlice,
  TrackerReferenceSlice,
  EmailSlice,
  AiChatListSlice,
  AgenticSlice,
  AgenticHireCandidateslice,
  AgenticInterviewSlice,
  AppliedInternshipSlice,
  DesignationSlice,
  EducationListSlice,
  EmailTemplateSlice,
  FaqSlice,
  FilterSlice,
  HotLeadSlice,
  HotVacancySlice,
  IndustrySlice,
  CategorySlice,
  LeadFeedbackSlice,
  SaveProfileSlice,
  UserSearchesSlice,
  StateCountrySlice,
  EventsSlice,
  CvSlice,
  PricingSlice,
  CouponSlice,
  RLeadSlice,
  TempUserSlice,
  MarketingLeadSlice,
  BulkResumeSlice,
  ResumeShortListSlice,
  JobRequireSlice,
  JobFairSlice,
  EndToEndHiringSlice,
  CustomerSupportActivitySlice,
  CounterSlice,
  ResumeDownloadTimerSlice,
  InstituteQrSlice,


  // Fraction Slice
  AnalyticFracSlice,
  PropertySlice,
  ClientSlice,
  PurchasedPropertySlice,
  InquiryFractionSlice,
  RequestSlice,
  LlpFractionSlice,
  BuilderSlice,
  LaunchSlice,
  LeaveSlice,
  SSLSlice,
  OrderSlice,
  SubscriptionSlice,
  paymentSlice,

  // Real Estate Slice
  PropertiesSlice,
  AboutSlice,
  ServicesSlice,
  DeveloperSlice,
  CompanyGoalSlice,
  UsersSlice,
  AuthenticationSlice,
  RealEstateLeadSlice,

  // Humming slice
  ContactsSlice,
  EmojisSlice,
  MessagesSlice,
  ReportSlice,
  RoomsSlice,
  SettingSlice,
  ScheduledMessageSlice,
  AllUserSlice,
  // PAYROLL CONTRACT SLICE
  PayrollContractSlice,
  SalaryStructureSlice,
  PayrollRulesSlice,
  GeneratePayrollSlice,
});



export default rootReducer;








